import { css, cx } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import ReactTooltip from 'react-tooltip';
import { Stack, Inline, Text, textVariants } from '@etg/wings';
import { useEffect, useState } from 'react';
import { screenReaderOnly } from '../../../common/utils/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const genericStyles = css`
  min-width: 240px;
  /* stylelint-disable-next-line declaration-no-important */
  padding: 16px !important;
`;
const inlineStyles = css`
  justify-content: space-between;
`;
const SeatToolTipWithPriceBreakdown = _ref => {
  var _markup$value;
  let {
    carrier,
    id,
    markup,
    price,
    seat,
    seatTypeLabel
  } = _ref;
  const {
    t
  } = useTranslation();
  const [seatId, setSeatId] = useState('');
  useEffect(() => {
    setSeatId(id);
  }, [id]);
  const labels = {
    markup: t('Product.Markup.Label'),
    pricebreakdown: t('ScreenReader.Product.Pricebreakdown.Label'),
    seat: t('OrderDetails.Passenger.Drawer.Seat.Title')
  };
  const normalizedMarkup = typeof markup === 'number' ? markup : (_markup$value = markup === null || markup === void 0 ? void 0 : markup.value) !== null && _markup$value !== void 0 ? _markup$value : 0;
  const formattedPrice = priceUtil.formatPrice(price);
  const markupPrice = priceUtil.formatPrice(normalizedMarkup);
  const providerPrice = priceUtil.formatPrice(price - normalizedMarkup);
  const priceBreakdownText = t('Product.Carrier.PriceBreakdown.Text', `${carrier.name} ${providerPrice}`, `${labels.markup} ${markupPrice}`);
  const screenReaderText = `${seatTypeLabel}. ${labels.seat} ${seat} ${formattedPrice}. ${labels.pricebreakdown}: ${priceBreakdownText}`;
  return /*#__PURE__*/_jsxs(ReactTooltip, {
    className: cx('etiTooltip', genericStyles),
    effect: "solid",
    event: "focus mouseover",
    eventOff: "blur mouseout",
    globalEventOff: "touchstart blur",
    id: id,
    children: [/*#__PURE__*/_jsxs(Stack, {
      "aria-hidden": "true",
      spacing: 4,
      children: [/*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        className: inlineStyles,
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: `${labels.seat}: ${seat}`
        }), /*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: formattedPrice
        })]
      }), carrier && /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        className: inlineStyles,
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          children: carrier.name
        }), /*#__PURE__*/_jsx(Text, {
          children: providerPrice
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        className: inlineStyles,
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          children: labels.markup
        }), /*#__PURE__*/_jsx(Text, {
          children: markupPrice
        })]
      })]
    }), /*#__PURE__*/_jsx("span", {
      className: screenReaderOnly,
      children: screenReaderText
    })]
  }, `key-${seatId}`);
};
export default SeatToolTipWithPriceBreakdown;
//# sourceMappingURL=SeatTooltipWithPriceBreakdown.js.map